var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtmIcnClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 10.75C1.5 5.64137 5.64137 1.5 10.75 1.5C15.8586 1.5 20 5.64137 20 10.75C20 15.8586 15.8586 20 10.75 20C5.64137 20 1.5 15.8586 1.5 10.75ZM10.75 0C4.81294 0 0 4.81294 0 10.75C0 16.6871 4.81294 21.5 10.75 21.5C16.6871 21.5 21.5 16.6871 21.5 10.75C21.5 4.81294 16.6871 0 10.75 0ZM11.5 4.75C11.5 4.33579 11.1642 4 10.75 4C10.3358 4 10 4.33579 10 4.75V10.75C10 11.0341 10.1605 11.2938 10.4146 11.4208L14.4146 13.4208C14.7851 13.6061 15.2356 13.4559 15.4208 13.0854C15.6061 12.7149 15.4559 12.2644 15.0854 12.0792L11.5 10.2865V4.75Z",
    fill: "#444EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmIcnClock);
export default __webpack_public_path__ + "static/media/atm-icn-clock.771ccd24b01d2ca809b7680beb7c7cc9.svg";
export { ForwardRef as ReactComponent };